// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2uV3U","label":"LabeledBox_label__2fEha"};